<template>
  <section class="excess-form">
    <div class="form-half">
      <div class="form-item">
        <span>Surgical</span>
        <v-input
          v-model="formData.surgical_ex"
          :keyNumber="true"
          :int="true"
          maxlength="8"
          :disabled="disabled"/>
      </div>
      <div class="form-item">
        <span>Personal Effects</span>
        <v-input
          v-model="formData.person_eff_ex"
          :keyNumber="true"
          :int="true"
          maxlength="8"
          :disabled="disabled"/>
      </div>
      <div class="form-item">
        <span>Fidelity Coverage</span>
        <v-input
          v-model="formData.fidelity_cov_ex"
          :keyNumber="true"
          :int="true"
          maxlength="8"
          :disabled="disabled"/>
      </div>
      <div class="form-item">
        <span>Personal Liability</span>
        <v-input
          v-model="formData.person_lia_ex"
          :keyNumber="true"
          :int="true"
          maxlength="8"
          :disabled="disabled"/>
      </div>
      <div class="form-item">
        <span>Excess Remark</span>
        <v-input
          v-model="formData.remark "
          type="textarea"
          :rows="4" />
      </div>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'

export default {
  name: 'HousemaidExcessForm',
  mixins: [MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      oldFormDataLock: -1,
      formData: {
        surgical_ex: '',
        person_eff_ex: '',
        fidelity_cov_ex: '',
        person_lia_ex: ''
      },
    }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      // deep: true,
      handler(val) {
        // if(this.formDataLock !== this.oldFormDataLock) {
        //   this.oldFormDataLock = this.formDataLock
        Object.keys(this.formData).some(key => {
          if(key in val) {
            this.formData[key] = val[key]
          }
        })
        // }
      }
    }
  },
  methods: {
    submitForm() {
      const params = JSON.parse(JSON.stringify(this.formData))
      this.$emit('getFormData', params)
      return params
    }
  }
}
</script>

<style lang="scss" scoped>
.excess-form {
    .flex-excess {
            display: flex;
            align-items: center;
            & > .el-checkbox {
                margin: 0 15px;
            }
            & > span {
                display: inline-block;
                padding: 0 15px;
            }
        }
        .form-excess-half {
            width: 500px;
        }
}
</style>
